// extracted by mini-css-extract-plugin
export default {"PlanBadge":"PlanBadge_PlanBadge__u4-HB","scrollBackground":"PlanBadge_scrollBackground__cXlH5"};